import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PixeModalState {
  isOpen: boolean;
  key: string;
}

const initialState: PixeModalState = {
  isOpen: false,
  key: ''
};

const pixeModalSlice = createSlice({
  name: 'pixeModal',
  initialState,
  reducers: {
    close: (state) => {
      state.isOpen = false;
      state.key = '';
    },
    open: (state, action: PayloadAction<string>) => {
      console.log('Opening modal with key:', action.payload);
      state.isOpen = true;
      state.key = action.payload;
    },
  },
});

export const { close, open } = pixeModalSlice.actions;

// Selector to get the modal key
export const selectModalKey = (state: { pixeModal: PixeModalState }) => state.pixeModal.key;
// Selector to check if the modal is open
export const selectIsOpen = (state: { pixeModal: PixeModalState }) => state.pixeModal.isOpen;

export default pixeModalSlice.reducer;
